export default "__VITE_ASSET__Be0z4ifw__"